/**
 * Generate repeatable random numbers.
 */
const random = {


	/**
	 * Set the random seed.
	 */
	seed: 0,


	/**
	 * Generate a random number using a random seed so that we can get consistent behaviour.
	 *
	 * @return {number}
	 */
	gen: function() {

		this.seed++;

		var x = Math.sin( this.seed ) * 10000;

		return x - Math.floor( x );

	},


	/**
	 * Generate a random integer between 2 values.
	 *
	 * @param {number} num1 Range value 1.
	 * @param {number} num2 Range value 2.
	 * @return {int}
	 */
	integer: function( num1 = 100, num2 = 0 ) {

		const min = Math.min( num1, num2 );
		const max = Math.max( num1, num2 );

		return Math.floor( random.gen() * ( max - min + 1 ) + min );

	},


	/**
	 * Generate a random number (float) between 2 numbers.
	 *
	 * @param {number} num1 Range value 1.
	 * @param {number} num2 Range value 2.
	 * @return {float}
	 */
	number: function( num1 = 100, num2 = 0 ) {

		const min = Math.min( num1, num2 );
		const max = Math.max( num1, num2 );

		return random.gen() * ( max - min ) + min;

	},


	/**
	 * Set a random seed.
	 *
	 * @return {number}
	 */
	random_seed: function() {

		let d = new Date();
		let seed = d.getTime().toString();
		this.seed = Math.round( seed.substring( seed.length - 5 ) );

		return this.seed;

	},


	/**
	 * Check against a probability chance of doing something.
	 *
	 * @param {number} chance The percentage chance to check against.
	 * @return {boolean}
	 */
	percent: function( chance ) {

		let number = this.gen() * 100;

		if ( number < chance ) {
			return true;
		}

		return false;

	},


};
